import React, { Component, Fragment } from 'react';
import { translate } from 'react-i18next';
import InputMask from 'react-input-mask';
import { Link } from 'react-router-dom';
import { request } from '../../../config';
import Loading from './../Loading/Loading';
class Campaigns extends Component {
    state = {
        campaigns: [],
        isLoading: false
    }

    componentDidMount() {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
        this.setState({ isLoading: true });

          // TODO
          // maybe it will be needed
        // let getCampaignListRequestBody = {
        //     lang: localStorage.getItem('i18nextLng').toUpperCase()
        // }
        // if (localStorage.getItem('compId')) {
        //     getCampaignListRequestBody.compId = parseInt(localStorage.getItem('compId'));
        // }
        // fetch(request("util/getCampaignList", getCampaignListRequestBody))
            // .then(res => res.text())
            // .then((getCampaignListResponseJSON) => {
            //     const JSON = require('true-json-bigint');
            //     let getCampaignListResponse = JSON.parse(getCampaignListResponseJSON);
            //     if (getCampaignListResponse.status.statusCode !== 1) {
            //         if (getCampaignListResponse.status.statusCode === 200) {
            //             this.props.logout();
            //         } else {
            //             this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(getCampaignListResponse.status.statusCode));
            //             this.setState({ isLoading: false });
            //         }
            //     }
            //     else {
            //         getCampaignListResponse.respCampaignList.map((item, index) => {
            //             getCampaignListResponse.respCampaignList[index].image = 'data:image/;base64,' + getCampaignListResponse.respCampaignList[index].image;
            //         });
                    this.setState({ campaigns: JSON.parse(localStorage.getItem("campaigns")) });
                    this.setState({ isLoading: false });
            //     }
            // },
                // (error) => {
                //     this.props.history.push("/technical-break");
                // });
    }

    render() {
        let { t, history } = this.props;
        let { campaigns, isLoading } = this.state;
        return (
            <Fragment>
                <div className="dashboard-header-route">
                    <div className="dashboard-header-route-left">
                        <button onClick={() => this.props.history.goBack()}>
                            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11.7344 21.2188L12.6719 20.3281C12.9062 20.0938 12.9062 19.7188 12.6719 19.5312L5.40625 12.2188H21.4375C21.7188 12.2188 22 11.9844 22 11.6562V10.3438C22 10.0625 21.7188 9.78125 21.4375 9.78125H5.40625L12.6719 2.51562C12.9062 2.32812 12.9062 1.95312 12.6719 1.71875L11.7344 0.828125C11.5469 0.59375 11.1719 0.59375 10.9375 0.828125L1.14062 10.625C0.90625 10.8594 0.90625 11.1875 1.14062 11.4219L10.9375 21.2188C11.1719 21.4531 11.5469 21.4531 11.7344 21.2188Z" fill="#2E3131" />
                            </svg>
                        </button>
                        <h2>{t('Campaigns')}</h2>
                    </div>
                </div>
                {
                    isLoading ?
                        <div className="dashboard-container-main-section">
                            <Loading />
                        </div>
                        :
                        <div className="dashboard-container-main-section">
                            <div className="dashboard-campaigns-section">
                                {
                                    campaigns.map((campaign, index) => (
                                        <Link to={`/dashboard/service-network/campaigns/${campaign.campaignId}`} className="dashboard-campaigns-section-item" key={index}>
                                            <div className="dashboard-campaigns-section-item-image" style={{ backgroundImage: `url(${campaign.image})` }}></div>
                                            <div className="dashboard-campaigns-section-item-content">
                                                <h3 className="dashboard-campaigns-section-item-title">{campaign.name}</h3>
                                                <p className="dashboard-campaigns-section-item-subtitle">{campaign.note}</p>
                                            </div>
                                        </Link>
                                    ))
                                }

                            </div>
                        </div>
                }

            </Fragment>
        )
    }
}
export default translate("translation")(Campaigns);
